import {observable} from "mobx";
import DB from "../../components/DB";
import _ from "lodash";
import {callWithCatch, tourneyUrl} from "@/utils.js";

let store = observable({
  showPlayer: null,
  registered: false,
  cart: gon.cart,
  regTo: null,
  division: null,
  myRegs: gon.regs,
  tevents: gon.tevents,
  teamsType: 'teams',
  dateFilter: gon.date_filter,
  loading: false,
  refreshTokens: {
    reg_change: 0,
  },
  triggerRefresh: (type) => {
    store.refreshTokens[type]++;
  },
  reload: () => {
    callWithCatch({
      setLoading: v => store.loading = v,
      url: tourneyUrl(""),
      method: 'get',
      params: { run_reload: true },
      onSuccess: data => {
        store.tevents = data.tevents;
      }
    });
  }
});

let initDivisions = () => {
  DB.divisions = gon.divisions || _.flatMap(store.tevents, 'play_divisions');
}
gon.tournament && store.tevents && initDivisions();


export default store;